import {
  type AnyAction,
  type Middleware,
  type MiddlewareAPI,
  type ThunkDispatch,
} from '@reduxjs/toolkit';
import {
  mapper
} from '@shared/lib';
import {
  setAppVersion,
  checkAppVersionSlice,
  type CheckAppVersionState,
} from '../model';

type AppVersionInfo = { version: Maybe<string> };
type MapToAppVersionInfo = (data: unknown) => AppVersionInfo;
const mapToAppVersionInfo: MapToAppVersionInfo = mapper([
  {
    name: 'version',
    from: 'meta.baseQueryMeta.response.headers',
    transform: (headers: Maybe<Headers>) => headers?.get('X-App-Version'),
  }
]);

type RootState = { [checkAppVersionSlice.name]: CheckAppVersionState; };
type AppDispatch = ThunkDispatch<RootState, unknown, AnyAction>;

export const handleStoreAppVersionMiddleware: Middleware = (store: MiddlewareAPI<AppDispatch, RootState>) => next => action => {
  const isStrapiApiRequest = (action as AnyAction)?.type.startsWith('api/executeQuery/');
  const hasStoredAppVersion = store.getState()[checkAppVersionSlice.name]?.appVersion;
  if (isStrapiApiRequest && !hasStoredAppVersion) {
    const appVersionInfo = mapToAppVersionInfo(action);
    if (appVersionInfo?.version) store.dispatch(setAppVersion(appVersionInfo.version));
  }

  return next(action);
};